import { useEffect, useState } from 'react';
import Container from "layouts/container/Container";
import { requester } from 'App';

function TestPaymentPage() {
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        // 스크립트 URL을 생성합니다.
        const jsUrl = "https://tapi.nestpay.co.kr/static/v1/public/nestpay.v1.js?ver=" + Math.random();
        const jsElement = document.createElement("script");

        jsElement.src = jsUrl;
        jsElement.onload = function () {
            // 스크립트 로드가 완료되면 NESTPAY.welcome() 함수를 호출합니다.
            if (window.NESTPAY) {
                window.NESTPAY.welcome();
            }
        };

        // 생성한 스크립트 엘리먼트를 document.head에 추가합니다.
        document.head.appendChild(jsElement);

        setMounted(true)
        // 컴포넌트 언마운트 시 스크립트 제거
        return () => {
            document.head.removeChild(jsElement);
        };
    }, []);
    useEffect(() => {
        
        if (isMounted) {
            let data = {
                "ready": {
                    "trackId": "ORD_1666052784",
                    "payMethod": "keyin",
                    "amount": 20000,
                    "taxAmt": 9091,
                    "taxFreeAmt": 10000,
                    "vatAmt": 909,
                    "serviceAmt": 0,
                    "returnUrl": "https://tapi.nestpay.co.kr/static/demoRslt.html",
                    "payerName": "홍길동",
                    "payerEmail": "paynest@paynest.com",
                    "payerTel": "010-3496-0098",
                    "payerId": "testID123",
                    "payerAddr": "TestCity Address 123-12",
                    "products": [
                        {
                        "name": "test goods",
                        "qty": 1,
                        "price": 19091
                        }
                    ]
                }
           }
            requester.testPayment(data, (result) => {
                
            })
        }

    }, [isMounted])

    return (
        <Container>
            <Container maxWidth={1200}>
                <div>sdf</div>
            </Container>
        </Container>
    );
}

export default TestPaymentPage;